// Resurrect 64 by Kerrie Lake (Lospec). The ONLY colors allowed anywhere in the game.
// Keys are stable names used by sprite definitions and the UI.

export const PALETTE = {
  ink: 0x2e222f,
  night: 0x3e3546,
  dusk: 0x625565,
  mauveGrey: 0x966c6c,
  sand: 0xab947a,
  plumGrey: 0x694f62,
  lilacGrey: 0x7f708a,
  steel: 0x9babb2,
  paper: 0xc7dcd0,
  white: 0xffffff,
  maroon: 0x6e2727,
  rust: 0xb33831,
  vermilion: 0xea4f36,
  peach: 0xf57d4a,
  blood: 0xae2334,
  red: 0xe83b3b,
  orange: 0xfb6b1d,
  amber: 0xf79617,
  gold: 0xf9c22b,
  wine: 0x7a3045,
  brick: 0x9e4539,
  copper: 0xcd683d,
  bronze: 0xe6904e,
  brass: 0xfbb954,
  mud: 0x4c3e24,
  olive: 0x676633,
  moss: 0xa2a947,
  lime: 0xd5e04b,
  lemon: 0xfbff86,
  pine: 0x165a4c,
  forest: 0x239063,
  clover: 0x1ebc73,
  leaf: 0x91db69,
  pistachio: 0xcddf6c,
  charcoal: 0x313638,
  slate: 0x374e4a,
  sage: 0x547e64,
  celadon: 0x92a984,
  khaki: 0xb2ba90,
  deepTeal: 0x0b5e65,
  teal: 0x0b8a8f,
  neonTeal: 0x0eaf9b,
  mint: 0x30e1b9,
  ice: 0x8ff8e2,
  navy: 0x323353,
  indigo: 0x484a77,
  cobalt: 0x4d65b4,
  blue: 0x4d9be6,
  sky: 0x8fd3ff,
  aubergine: 0x45293f,
  purple: 0x6b3e75,
  violet: 0x905ea9,
  lavender: 0xa884f3,
  pinkLilac: 0xeaaded,
  mulberry: 0x753c54,
  rose: 0xa24b6f,
  dustyPink: 0xcf657f,
  salmonPink: 0xed8099,
  crimson: 0x831c5d,
  cerise: 0xc32454,
  flesh: 0xf04f78,
  coral: 0xf68181,
  apricot: 0xfca790,
  cream: 0xfdcbb0,
} as const;

export type PaletteKey = keyof typeof PALETTE;

export const PALETTE_KEYS = Object.keys(PALETTE) as PaletteKey[];
const PALETTE_SET = new Set<number>(Object.values(PALETTE));

export function isPaletteColor(rgb: number): boolean {
  return PALETTE_SET.has(rgb);
}

export function hex(key: PaletteKey): string {
  return '#' + PALETTE[key].toString(16).padStart(6, '0');
}

/** Semantic roles from docs/07 §1.1. */
export const ROLE = {
  bg: 'ink',
  bgMid: 'night',
  bgMid2: 'aubergine',
  shadow: 'purple',
  value: 'gold',
  mult: 'red',
  xmult: 'lavender',
  luck: 'mint',
  hunger: 'flesh',
  doom: 'crimson',
  souls: 'lavender',
  soulsLight: 'pinkLilac',
  receipt: 'paper',
  info: 'blue',
  led: 'brass',
  ledOff: 'aubergine',
} as const satisfies Record<string, PaletteKey>;
